import { gql, useLazyQuery } from "@apollo/client";
import React, { useEffect } from "react";
import { Layout, LegacyCard, SkeletonDisplayText, Text } from "@shopify/polaris";
import { useTranslation } from "react-i18next";

interface Props {
  totalBalance: string;
  holdBalance: string;
  availableBalance: string;
}

const QUERY = gql`
  query supplierBalanceSummary {
    supplierBalanceSummary {
      availableBalance
      holdBalance
      totalBalance
    }
  }
`;

export function HoldBalance() {
  const { t } = useTranslation();
  const config = {
    total_balance: t("page_dashboard.total_balance") || "Total Balance",
    hold: t("page_dashboard.hold") || "Hold",
    available: t("general.available") || "Available",
    more_detail: t("general.more_detail") || "More Detail",
  };
  const [supplierBalanceSummary, { data }] = useLazyQuery(QUERY, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    supplierBalanceSummary();
  }, [supplierBalanceSummary]);

  return (
    <>
      <Layout.Section variant="oneThird">
        <LegacyCard
          title={config.total_balance}
          actions={[{ content: config.more_detail, url: "/dashboard/balance/TOTAL", external: true }]}
        >
          <LegacyCard.Section>
            {data ? (
              <Text as="h4" variant="headingXl" tone="caution">
                ${Number(data.supplierBalanceSummary.totalBalance).toFixed(2)}
              </Text>
            ) : (
              <SkeletonDisplayText size="large" />
            )}
          </LegacyCard.Section>
        </LegacyCard>
      </Layout.Section>
      <Layout.Section variant="oneThird">
        <LegacyCard
          title={config.hold}
          actions={[{ content: config.more_detail, url: "/dashboard/balance/HOLD", external: true }]}
        >
          <LegacyCard.Section>
            {data ? (
              <Text as="h4" variant="headingXl" tone="critical">
                ${Number(data.supplierBalanceSummary.holdBalance).toFixed(2)}
              </Text>
            ) : (
              <SkeletonDisplayText size="large" />
            )}
          </LegacyCard.Section>
        </LegacyCard>
      </Layout.Section>
      <Layout.Section variant="oneThird">
        <LegacyCard
          title={config.available}
          actions={[{ content: config.more_detail, url: "/applications/disbursement/request", external: true }]}
        >
          <LegacyCard.Section>
            {data ? (
              <Text as="h4" variant="headingXl" tone="success">
                ${Number(data.supplierBalanceSummary.availableBalance).toFixed(2)}
              </Text>
            ) : (
              <SkeletonDisplayText size="large" />
            )}
          </LegacyCard.Section>
        </LegacyCard>
      </Layout.Section>
    </>
  );
}
